/**
 * Acción de REDUX que solicita el correo de restablecimiento de contraseña.
 *
 * Invoca la callable `requestPasswordReset` (daysi-cloud-functions), que
 * genera el link de Firebase y lo envía desde el mail.service con plantilla
 * propia. La respuesta es genérica (anti-enumeración): no revela si la
 * cuenta existe.
 */

import { AUTH } from '../../../application/types';

// Mismo patrón de callables que actions/auth/mfa.js
const callable = (firebase, name) => firebase().app().functions().httpsCallable(name);

/**
 * @param {string} email
 */
export const forgot = ( email ) => ( dispatch, state, firebase ) => {

  dispatch({ type: AUTH.LOGGINGIN });

  return callable(firebase, 'requestPasswordReset')({ email })
    .then( res => res.data )
    .catch( error => {
      dispatch({
        type: AUTH.ERROR,
        code: error.code,
        message: error.message
      });
      throw error; // el modal decide el mensaje según error.code
    });

};